import styled from 'styled-components';

import { purple7 } from 'approot/shared/styles/colours.style';
import { font18, PStyled } from 'approot/shared/styles/typography.style';

export const ActivityBuilderOfflineModalContent = styled(PStyled).attrs({
  colour: purple7,
  marginBottom: 0,
})`
  ${font18}
`;
